import { render, staticRenderFns } from "./tableSituations.vue?vue&type=template&id=e3a1c7d0"
import script from "./tableSituations.vue?vue&type=script&lang=js"
export * from "./tableSituations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports